import { useEffect, useState } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

/**
 * Whether the viewer's system asks for reduced motion.
 *
 * The answer starts as "no" rather than being read while the state is
 * initialised: the server has no media queries, and a first client render that
 * disagreed with the markup it is hydrating is a mismatch. The effect reads the
 * real answer immediately afterwards, so the difference is one frame.
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    const query = window.matchMedia?.(QUERY);
    if (!query) return;

    const onChange = () => setReduced(query.matches);
    onChange();
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  return reduced;
}
